import React from 'react'
import { Dialog } from '@mui/material'
import SurveyDetail from './SurveyDetail'
import { ScoredInstance } from './questionnaireHistory'

type Props = {
  open: boolean
  onClose: () => void
  label: string
  completed: boolean
  sentAt: string | null
  completedAt: string | null
  timezone: string | null | undefined
  instances: ScoredInstance[]
  scheduledFor?: string | null
  repeatCadenceInDays?: number | null
  onUnassign?: () => Promise<void>
  onAssignAgain?: () => Promise<void>
}

const SurveyDetailDialog = ({
  open,
  onClose,
  label,
  completed,
  sentAt,
  completedAt,
  instances,
  timezone,
  scheduledFor,
  repeatCadenceInDays,
  onUnassign,
  onAssignAgain,
}: Props) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <SurveyDetail
      key={label}
      label={label}
      onClose={onClose}
      completed={completed}
      sentAt={sentAt}
      completedAt={completedAt}
      instances={instances}
      timezone={timezone}
      scheduledFor={scheduledFor}
      repeatCadenceInDays={repeatCadenceInDays}
      onUnassign={
        onUnassign
          ? async () => {
              await onUnassign()
              onClose()
            }
          : undefined
      }
      onAssignAgain={
        onAssignAgain
          ? async () => {
              await onAssignAgain()
              onClose()
            }
          : undefined
      }
    />
  </Dialog>
)

export default SurveyDetailDialog
